import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  Button,
  Empty,
  Divider,
  InputNumber,
  Input,
  Select, Table
} from "antd";
import styled from "styled-components";
import ProductCard from "../productCard";
import { useHistory } from "react-router-dom";
import { BsChevronLeft } from "react-icons/bs";
import { BsChevronRight } from "react-icons/bs";
import { AiOutlinePlus } from "react-icons/ai";
import CustomModal from "../modals/customModal";
import LoaderGif from "../../assets/images/ie_loader.gif";

import Delete_order from "../../assets/images/delete_order.png";
import Configuration from "../../assets/images/configuration.png";
import { useSelector } from "react-redux";
const CatalogCardWrapper = styled(Card)`
  min-height: 350px;
  box-shadow: 0px 0px 5px 0px rgb(0 0 0 / 16%);
  margin-top: 30px;

  .table-filters {
    height: 2rem;
    text-align: center;
    border-color: #9e9e9e;
    border-radius: 0px;
    font-size: 14px;
    width: auto;
  }
  .table-filters-heading {
    font-size: 0.8rem;
    color: #000;
    padding-right: 16px;
  }
`;
let productData = [];
function CatalogCard({
  products,
  categoryName,
  onChangeFilter,
  onChangeShowingFilter,
  previousPage,
  currentPage,
  metaData,
  updateProductPrice,
  onUpdateProductPrice,
  onOpenModal,
  value,
  updateProduct,
  fromNewCatalog,
  NewCatalogInput,
  postProduct,
  isLoading,
  callOnCallBack,
  isProductLoading,
  dividerShow,
  iscardTrue,
  onAdd,
}) {
  const history = useHistory();
  let [isOpenModal, setIsOpenModal] = useState(false);
  const [productId, setProductId] = useState("");
  const [configModal, setConfigModal] = useState(false);
  const [product, setProduct] = useState({});
  const [priceError, setPriceError] = useState("");
  const [currentIndex, setIndex] = useState(0);
  const [editedProduct, setEditedProduct] = useState([]);
  const [editedIndex, setEditIndex] = useState(0);
  const [additiveErr, setAdditiveErr] = useState([]);
  const [priceData, setPriceData] = useState(product?.rmx_product_prices?.map(({ rmx_product_price }) => ({ ...rmx_product_price, unit: product?.unit })));
  const [price, setPrice] = useState(0);
  const [selectedCurrency, setSelectedCurrency] = useState("");
  const [currency, setCurrency] = useState('USD');
  const [pricing, setPricing] = useState('0');
  const [staticPriceData, setStaticPriceData] = useState([]);
  // a state to track the added products just so we can handle the add or edit flow properly.
  const [trackAddedProducts, setTrackAddedProducts] = useState([]);
  const [trackAddedProduct, setTrackAddedProduct] = useState(null);
  const [customRender, setCustomRender] = useState(false);

  console.log("staticPriceData==>", staticPriceData);
  console.log("priceData==>", priceData);
  console.log("productId==>", productId);
  console.log("trackAddedProduct==>", trackAddedProducts)
  console.log("current_price==>", price)
  useEffect(() => {
    if (product?.rmx_product_prices) {
      console.log('product?.rmx_product_price', product?.rmx_product_prices[0]?.price)
      setPriceData(product?.rmx_product_prices?.map(({ rmx_product_price }) => ({ ...rmx_product_price, unit: product?.unit })));
      setPrice(product?.rmx_product_prices[0]?.rmx_product_price?.price || 0);
      setSelectedCurrency(product?.rmx_product_prices[0]?.rmx_product_price?.currency || "");
    }
  }, [product?.rmx_product_prices]);

  // console.log("selectedCurrency==>", selectedCurrency);

  const handleCurrencyChange = (value) => {
    // console.log(`selected ${value}`);
    setSelectedCurrency(value);
    setPrice(priceData.find(p => p.currency === value)?.price || 0);
  };

  // console.log("priceData==>", priceData);

  useEffect(() => {
    productData = []
  }, [])

  useEffect(() => {
    if (products) {
      setEditedProduct(products);
    }
  }, [products]);

  const onUpdateRmxPrice = (e, index) => {
    const arr = { ...product };
    arr.rmx_product_additives[index].price = e;
    additiveErr[index] = null;
    setAdditiveErr(additiveErr);

    setProduct(arr);
    setPriceError(true);
  };

  const clearConfigModalStates = () => {
    setStaticPriceData([]);
    setCurrency('USD');
    setPricing(0);
  }

  const onChangeOnAdd = (e, index, name) => {
    const arr = { ...product };
    arr.product_additives[index] = {
      name,
      description: "",
      price: e,
    };
    additiveErr[index] = null;
    setAdditiveErr(additiveErr);
    setProduct(arr);
    setPriceError("");
  };

  const onAddProduct = () => {
    const arr = [];
    (product.product_additives || []).forEach((v, index) => {
      if (!v.price) {
        arr[index] = "error";
      }
    });
    setAdditiveErr(arr);
    const errorCheck = arr.some((item) => {
      return item === "error";
    });

    // if (product.price) {
    //   if (errorCheck) {
    //     return;
    //   }
    //   productData.push({ ...product, isSave: true });
    //   setConfigModal(false);
    //   console.log("productAdd==>", product);
    //   console.log("onAdd==>", onAdd);
    //   alert("before in==>");
    //   if (onAdd) {
    //     onAdd(productData);
    //     alert("in==>");

    //   }
    // } else {
    //   setPriceError("Price is required.");
    // }

    // if(product){
    //   productData?.push({ ...product, productPrices: priceData });
    //   setConfigModal(false);
    // }

    if (Object.values(staticPriceData).length > 0) {
      productData?.push({ ...product, productPrices: Object.values(staticPriceData).map(({ currency, price }) => ({ currency: currency, price: price })) });
      setConfigModal(false);
    }
    // console.log('static price data before productdata', Object.values(staticPriceData).map( ({currency, price}) => ({currency: currency, price: price})));

    // console.log("productData==>", productData);


  };

  const updatePriceOfProduct = (e) => {
    setPrice(e);
    // console.log("selectedCurrency==>", selectedCurrency);

    const updated = priceData.map(p =>
      p.currency === selectedCurrency ? { ...p, price: e } : p
    );
    setPriceData(updated);

  };

  console.log("afterupdatingPrice", priceData)

  const updatePriceOfProd = (e) => {
    const arr = { ...product };
    const abc = [...editedProduct];
    abc[editedIndex]["price"] = e;
    setEditedProduct(abc);
    arr.price = e;
    setProduct(arr);
  };
  console.log('productData==>', productData)

  const setCloseHandler = () => {

  }

  const inputChangeHandler = (e) => {
    setPricing(e);
    setTrackAddedProducts((prev) => {
      const existingProductIndex = prev.findIndex(p => p.productId === trackAddedProduct?.id);

      if (existingProductIndex !== -1) {
        // Update existing product's currency
        const updatedProducts = [...prev];
        updatedProducts[existingProductIndex] = {
          ...updatedProducts[existingProductIndex],
          [currency]: { currency, price: e }
        };
        return updatedProducts;
      } else {
        // Add new product entry
        return [
          ...prev,
          {
            productId: trackAddedProduct?.id,
            [currency]: { currency, price: e }
          }
        ];
      }
    });
    setStaticPriceData({ ...staticPriceData, [currency]: { currency: currency, price: e } });
  }


  let val = trackAddedProducts.find(item => item?.productId == trackAddedProduct?.id)
  console.log('traceValuesproductId==>', productId)


  return (
    <Row>
      <Col span={24} style={{ paddingLeft: "13px" }}>
        {iscardTrue ? (
          <>
            <Row
              justify="space-between"
              style={{
                borderBottom: dividerShow && "1px solid lightgrey"
              }}
            >
              <Col xl={12} xs={24} sm={24} md={12}>
                <h5 className="text-left" style={{ paddingLeft: "12px" }}>
                  {categoryName}
                </h5>
              </Col>
              <Col xl={12} xs={24} sm={24} md={12}>
                {!fromNewCatalog && (
                  <h2
                    className="text-right pointer-cursor"
                    onClick={() => history.push("/catalog/new")}
                  >
                    <AiOutlinePlus size={20} className="pointer-cursor" />
                  </h2>
                )}
              </Col>
            </Row>
            <Row
              justify="space-between"
              style={{ paddingTop: "0.5rem", paddingBottom: "0.5rem" }}
            >
              <Col xl={4} lg={4} md={4} sm={7} xs={7}>
                <span
                  style={{
                    fontSize: "0.8rem",
                    color: "#9e9e9e",
                    paddingRight: "10px",
                  }}
                >
                  Sort by
                </span>
                <select
                  style={{
                    height: "2rem",
                    textAlign: "center",
                    borderColor: "#9e9e9e",
                    borderRadius: "0px",
                    fontSize: "14px",
                    width: "auto",
                  }}
                  onChange={(e) => onChangeFilter(e.target.value)}
                >
                  <option>Price</option>
                  <option>Name</option>
                </select>
              </Col>
              <Col
                xl={4}
                lg={4}
                md={4}
                sm={7}
                xs={7}
                style={{
                  paddingLeft: "11px",
                }}
              >
                <span
                  style={{
                    fontSize: "0.8rem",
                    color: "#9e9e9e",
                    paddingRight: "10px",
                  }}
                >
                  Showing
                </span>
                <select
                  style={{
                    height: "2rem",
                    textAlign: "center",
                    borderColor: "#9e9e9e",
                    borderRadius: "0px",
                    fontSize: "14px",
                    width: "auto",
                  }}
                  onChange={(e) => onChangeShowingFilter(e.target.value)}
                >
                  <option>12</option>
                  <option>24</option>
                  <option>48</option>
                  <option>96</option>
                </select>
              </Col>
            </Row>
            <Row>
              {products.length ? (
                products.map((item, index) => {
                  return (
                    <Col xl={8} lg={8} md={6} xs={24} sm={24}>
                      <ProductCard
                        fromNewCatalog={fromNewCatalog}
                        data={item}
                        onAdd={(e) => {
                          setConfigModal(true);
                          setProductId(item.id);
                          setProduct(item);
                          onOpenModal(item.price);
                          setIndex(index);
                          setPriceError("");
                        }}
                        onConfigure={(e) => {
                          setConfigModal(true);
                          setProductId(item.id);
                          setProduct(item);
                          onOpenModal(item.price);
                          setPriceError("");
                        }}
                        onDeactive={(e) => {
                          setIsOpenModal(true);
                          setProductId(item.id);
                          setProduct(item);
                        }}
                        productData={productData}
                      />
                    </Col>
                  );
                })
              ) : (
                <Col span={24}>
                  {isLoading && (
                    <img src={LoaderGif} height={"60"} width={"60"} />
                  )}
                  {!isLoading && (
                    <Empty description={"Nothing to show right now."} />
                  )}
                </Col>
              )}
            </Row>
            {products.length !== 0 && (
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <Row
                  gutter={[5, 0]}
                  xs={24}
                  sm={24}
                  md={24}
                  lg={24}
                  xl={24}
                  justify="start"
                >
                  <Col className="tablePagination">
                    {console.log("metaData==>", metaData)}
                    {`Displaying ${metaData?.current_page !== metaData?.total_pages
                      ? metaData?.current_records * metaData?.current_page
                      : metaData?.total_records
                      } of ${metaData?.total_records}`}
                    <Button
                      type="link"
                      icon={<BsChevronLeft color="#686868" size={15} />}
                      onClick={previousPage}
                      disabled={metaData?.current_page === 1}
                    />
                    <Button
                      type="link"
                      icon={<BsChevronRight color="#686868" size={15} />}
                      onClick={currentPage}
                      disabled={
                        metaData?.total_pages === metaData?.current_page
                      }
                    />
                  </Col>
                </Row>
              </Col>
            )}
          </>
        ) : (
          <CatalogCardWrapper>
            <Row
              justify="space-between"
              style={{
                borderBottom: dividerShow && "1px solid lightgrey",
                marginBottom: "15px",
              }}
            >
              <Col
                span={12}
                xl={12}
                xs={24}
                sm={24}
                style={{ marginBottom: "7px" }}
              >
                <h5 className="text-left">{categoryName}</h5>
              </Col>
              <Col span={12} xl={12} xs={24} sm={24}>
                {!fromNewCatalog && (
                  <h2
                    className="text-right pointer-cursor"
                    onClick={() => history.push("/catalog/new")}
                  >
                    <AiOutlinePlus size={20} className="pointer-cursor" />
                  </h2>
                )}
              </Col>
            </Row>
            <Row
              justify="space-between"
              style={{ padding: "1rem 0rem 0.2rem" }}
            >
              <Col xl={4} lg={4} md={4} sm={7} xs={7}>
                <span className="table-filters-heading">Sort by</span>
                <select
                  className="table-filters"
                  onChange={(e) => onChangeFilter(e.target.value)}
                >
                  <option>Price</option>
                  <option>Name</option>
                </select>
              </Col>
              <Col xl={4} lg={4} md={4} sm={7} xs={7}>
                <span className="table-filters-heading">Showing</span>
                <select
                  className="table-filters"
                  onChange={(e) => onChangeShowingFilter(e.target.value)}
                >
                  <option>12</option>
                  <option>24</option>
                  <option>48</option>
                  <option>96</option>
                </select>
              </Col>
            </Row>
            <Row>
              {editedProduct.length ? (
                editedProduct.map((item, i) => {
                  return (
                    <Col xl={8} lg={8} md={9} xs={24} sm={24}>
                      <ProductCard
                        fromNewCatalog={fromNewCatalog}
                        data={item}
                        onAdd={(e) => {
                          setConfigModal(true);
                          setProductId(item.id);
                          setProduct({ ...item });
                          onOpenModal(item.price);
                          setEditIndex(i);
                          setPriceError("");
                          setAdditiveErr([]);
                        }}
                        onConfigure={(e) => {
                          setConfigModal(true);
                          setProductId(item.id);
                          setProduct(item);
                          onOpenModal(item.price);
                          setPriceError("");
                          setAdditiveErr([]);
                          setPrice(product?.rmx_product_prices?.length > 0 ? product?.rmx_product_prices[0]?.rmx_product_price?.price : 0)
                        }}
                        onDeactive={(e) => {
                          setIsOpenModal(true);
                          setProductId(item.id);
                          setProduct(item);
                        }}
                        sendingProductToParent={(product) => setTrackAddedProduct(product)}
                        productData={productData}
                      />
                    </Col>
                  );
                })
              ) : (
                <Col span={24}>
                  {isLoading && (
                    <img src={LoaderGif} height={"60"} width={"60"} />
                  )}
                  {!isLoading && (
                    <Empty description={"Nothing to show right now."} />
                  )}
                </Col>
              )}
            </Row>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Row
                gutter={[5, 0]}
                xs={24}
                sm={24}
                md={24}
                lg={24}
                xl={24}
                justify="end"
              >
                <Col className="tablePagination">
                  {`Displaying ${metaData?.current_page !== metaData?.total_pages
                    ? metaData?.current_records * metaData?.current_page
                    : metaData?.total_records
                    } of ${metaData?.total_records}`}
                  <Button
                    type="link"
                    icon={<BsChevronLeft color="#686868" size={15} />}
                    onClick={previousPage}
                    disabled={metaData?.current_page === 1}
                  />
                  <Button
                    type="link"
                    icon={<BsChevronRight color="#686868" size={15} />}
                    onClick={currentPage}
                    disabled={metaData?.total_pages === metaData?.current_page}
                  />
                </Col>
              </Row>
            </Col>
          </CatalogCardWrapper>
        )}

        <CustomModal
          visible={configModal}
          destroyOnClose={true}
          onCancelModal={
            () => {
              setConfigModal(false)
              // setting back to default value
              setCurrency('USD');
            }
          }
          afterCloseFunc={() => setCloseHandler()}
          footer={[
            <Row justify="end">
              <Col span={24} style={{ width: "100%" }}>
                <Button
                  style={{
                    backgroundColor: "#fff",
                    color: "black",
                    width: "30%",
                    border: "none",
                  }}
                  onClick={() => {
                    setConfigModal(false);
                    clearConfigModalStates();
                    // setting back to default value
                    setCurrency('USD');
                    setTrackAddedProducts((prev) => {
                      let cloneOfTrackAddedProducts = [...prev];
                      let productIndex = cloneOfTrackAddedProducts.findIndex(item => item?.productId == trackAddedProduct?.id);
                      if (productIndex !== -1) {
                        cloneOfTrackAddedProducts.splice(productIndex, 1);
                      }
                      return cloneOfTrackAddedProducts
                    })
                    let productIndex = productData?.findIndex(item => item?.id == trackAddedProduct?.id);
                    productIndex !== -1 && productData?.splice(productIndex, 1);
                    // a state just to trigger a rerender just because i dont want to manupilate the current flow of work.
                    setCustomRender(!customRender)
                  }}
                >
                  CANCEL
                </Button>

                {!NewCatalogInput ? (
                  <Button
                    style={{
                      backgroundColor: "#ff9800 ",
                      color: "#fff",
                      width: "30%",
                      border: "none",
                    }}
                    onClick={() => {
                      const arr = [];

                      (product.rmx_product_additives || []).forEach(
                        (v, index) => {
                          console.log("PRODUCT_ADDTITIVE==>", v);
                          if (!v.price) {
                            arr[index] = "error";
                          }
                        }
                      );
                      setAdditiveErr(arr);
                      const errorCheck = arr.some((item) => {
                        return item === "error";
                      });

                      // if (product.price) {
                      //   if (errorCheck) {
                      //     return;
                      //   }
                      // console.log("productAdd==>", product);

                      updateProductPrice(
                        priceData?.length > 0 ?
                          {
                            priceData: priceData,
                            rmx_product_additives: product.rmx_product_additives,
                          }
                          :
                          {
                            priceData: Object.values(staticPriceData).map(({ currency, price }) => ({ currency: currency, price: price })),
                            rmx_product_additives:
                              product.rmx_product_additives,
                          },
                        productId,
                        null,
                        () => {
                          setConfigModal(false);
                          clearConfigModalStates();
                          callOnCallBack();
                        }
                      );
                      // } else {
                      //   setPriceError("Price is required.");
                      // }
                    }}
                  >
                    SAVE
                  </Button>
                ) : (
                  <Button
                    style={{
                      backgroundColor: "#ff9800 ",
                      color: "#fff",
                      width: "30%",
                      border: "none",
                    }}
                    onClick={() => {
                      onAddProduct()
                      // setting back to default value
                      setCurrency('USD');
                    }}
                  >
                    SAVE
                  </Button>
                )}
              </Col>
            </Row>,
          ]}
        >
          {/* <Row justify="space-between" style={{ marginBottom: "30px" }}>
            <Col  xl={12}>
              <h5 className="text-left">{product?.name}</h5>
            </Col>
            <Col xs={12} sm={12} md={8} lg={8} xl={10} style={{ textAlign:'center' }}>
              <span style={{ paddingRight: "5px", fontSize: "1.1rem" }}>$</span>
              <InputNumber
                min={1}
                onChange={(e) => {
                  updatePriceOfProd(e, currentIndex);
                  setPriceError(true);
                }}
                name="price"
                value={product?.price?.toString()}
                type="number"
              />
              <span
                style={{
                  paddingLeft: "5px",
                  fontSize: "1.1rem",
                  color: "#323761",
                }}
              >
                {`/${product?.unit}`}
              </span>
              <Row>
                <Col
                  className="danger-color"
                  style={{
                    paddingLeft: "5px",
                    fontSize: "90%",
                    marginTop: "5px",
                  }}
                >
                  {priceError && priceError}
                </Col>
              </Row>
            </Col>
          </Row> */}
          <Row justify="space-between" style={{ marginBottom: "30px" }}>
            <Col xl={10}>
              <h5 className="text-left">{product?.name}</h5>
            </Col>
            <Col xs={12} sm={12} md={12} lg={12} xl={14} className="currency-select" style={{ textAlign: 'center' }}>
              {/* Currency Dropdown */}
              {priceData?.length > 0 ? (
                <>
                  <Select
                    defaultValue={priceData[0].currency}
                    onChange={handleCurrencyChange}
                    options={priceData.map((item) => ({
                      label: item.currency,
                      value: item.currency,
                    }))}
                  />
                  <InputNumber
                    min={1}
                    onChange={(e) => updatePriceOfProduct(e)}
                    name="price"
                    value={price}
                    defaultValue={priceData[0].price || 0}
                    type="number"

                  />
                </>
              ) :
                (
                  // <>
                  //   <span style={{ paddingRight: "5px", fontSize: "1.1rem" }}>$</span>
                  //   <InputNumber
                  //     min={1}
                  //     onChange={(e) => {
                  //       updatePriceOfProd(e, currentIndex);
                  //       setPriceError(true);
                  //     }}
                  //     name="price"
                  //     value={product?.price?.toString()}
                  //     type="number"
                  //   />
                  // </>

                  <>
                    <Select
                      defaultValue={'USD'}
                      onChange={(value) => {
                        console.log("value==>", value);
                        setCurrency(value);
                        setPricing(staticPriceData[value]?.price || 0);
                      }}
                      options={['USD', 'CA$'].map((item) => ({
                        label: item,
                        value: item,
                      }))}
                    />
                    <InputNumber
                      min={1}
                      onChange={(e) => inputChangeHandler(e)}
                      name="price"
                      value={
                        trackAddedProducts.find(item => item?.productId == trackAddedProduct?.id)?.[currency]?.price || 0
                        // pricing
                      }
                      defaultValue={0}
                      type="number"

                    />
                  </>
                )}

              <span
                style={{
                  paddingLeft: "5px",
                  fontSize: "1.1rem",
                  color: "#323761",
                }}
              >
                {`/${product?.unit}`}
              </span>
              <Row>
                <Col
                  className="danger-color"
                  style={{
                    paddingLeft: "5px",
                    fontSize: "90%",
                    marginTop: "5px",
                  }}
                >
                  {priceError && priceError}
                </Col>
              </Row>
            </Col>
          </Row>
          <Row justify="space-between" style={{ marginBottom: "30px" }}>
            <Col xl={24} xs={24} sm={24} md={24} lg={24}>

              {/* Currency Table */}
              {priceData?.length > 0 &&
                <Table
                  dataSource={priceData}
                  columns={[
                    { title: "Currency", dataIndex: "currency", key: "currency" },
                    { title: "Price", dataIndex: "price", key: "price" },
                    { title: "Unit", dataIndex: "unit", key: "unit" },
                  ]}
                  rowKey={(record, index) => index}
                  pagination={false}
                />
              }
              {/*static Currency Table */}
              {!priceData?.length &&
                trackAddedProduct && trackAddedProducts.find(item => item?.productId == trackAddedProduct?.id) &&
                <Table
                  dataSource={
                    Object.values(trackAddedProducts.find(item => item?.productId == trackAddedProduct?.id))
                    // Object.values(staticPriceData)
                  }
                  columns={[
                    { title: "Currency", dataIndex: "currency", key: "currency" },
                    { title: "Price", dataIndex: "price", key: "price" },
                  ]}
                  rowKey={(record, index) => index}
                  pagination={false}
                />
              }
            </Col>
          </Row>
          <Row>
            <Col span={9}>
              <img
                src={product?.image?.medium}
                style={{ objectFit: "contain", width: "90%" }}
              />
            </Col>
            <Col
              span={14}
              style={{
                border: "1px solid #F0F0F0",
                padding: "0.5rem",
                height: "auto",
              }}
            >
              <Row>
                <Col span={12} style={{ position: "relative" }}>
                  <img
                    src={Configuration}
                    style={{
                      width: "100%",
                      position: "absolute",
                      backgroundRepeat: "no-repeat",
                      top: "-20px",
                    }}
                  />
                </Col>
                <Col
                  span={24}
                  style={{
                    height: "8rem",
                    overflowY: "auto",
                    overflowX: "hidden",
                    margin: "5px",
                  }}
                >
                  { }
                  {!NewCatalogInput
                    ? (product.rmx_product_additives || []).map(
                      (item, index) => {
                        return (
                          <Row
                            justify="space-between"
                            align="middle"
                            style={{ marginBottom: "5px" }}
                          >
                            <Col span={14}>{item.name}</Col>
                            <Col span={10}>
                              <InputNumber
                                min={1}
                                max={100000}
                                onChange={(e) => onUpdateRmxPrice(e, index)}
                                name="price"
                                value={item.price}
                                type="number"
                              />
                            </Col>
                            <Col span={24}>
                              <Row justify="start">
                                <Col
                                  className="danger-color"
                                  style={{ fontSize: "0.75rem" }}
                                >
                                  {additiveErr[index] == "error"
                                    ? "Price is required"
                                    : ""}
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        );
                      }
                    )
                    : (product.product_additives || []).map((item, index) => {
                      return (
                        <Row
                          justify="space-between"
                          align="middle"
                          style={{ marginBottom: "5px" }}
                        >
                          <Col span={14}>
                            {product.additives[index]["name"]}
                          </Col>
                          <Col span={10}>
                            <InputNumber
                              min={1}
                              max={100000}
                              onChange={(e) =>
                                onChangeOnAdd(
                                  e,
                                  index,
                                  product.additives[index]["name"]
                                )
                              }
                              type="number"
                              name="price"
                              value={item.price}
                            />
                          </Col>
                          <Col span={24}>
                            <Row justify="start">
                              <Col
                                className="danger-color"
                                style={{ fontSize: "0.75rem" }}
                              >
                                {additiveErr[index] == "error"
                                  ? "Price is required"
                                  : ""}
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      );
                    })}
                </Col>
              </Row>
            </Col>
          </Row>
        </CustomModal>
        <CustomModal
          visible={isOpenModal}
          onCancelModal={() => setIsOpenModal(false)}
          footer={[
            <Row justify="center" style={{ margin: "20px" }}>
              <Col
                className="d-flex justify-content-center"
                style={{ width: "100%" }}
              >
                <Button
                  style={{
                    backgroundColor: "#ff9800",
                    color: "#fff",
                    width: "30%",
                    border: "none",
                  }}
                  onClick={() =>
                    updateProduct(
                      {},
                      productId,
                      product.status === 1 ? "deactivate" : "activate",
                      () => {
                        callOnCallBack();
                        setIsOpenModal(false);
                      }
                    )
                  }
                >
                  YES
                </Button>
                <Button
                  style={{
                    backgroundColor: "#26a69a ",
                    color: "#fff",
                    width: "30%",
                    border: "none",
                  }}
                  onClick={() => setIsOpenModal(false)}
                >
                  NO
                </Button>
              </Col>
            </Row>,
          ]}
        >
          <Row justify="center">
            <Col className="d-flex justify-content-center" span={24}>
              <img src={Delete_order} />
            </Col>
            <Col span={12} style={{ textAlign: "center" }}>
              <span>
                {product.status === 1
                  ? "Are you sure you want to deactivate this product"
                  : "Are you sure you want to activate this product"}
              </span>
            </Col>
          </Row>
        </CustomModal>

        {
          // productData.some((item) => item.id === productId) 
          productData?.length > 0
            && !onAdd ? (
            <Row justify="end">
              {isProductLoading ? (
                <img src={LoaderGif} height={"60"} width={"60"} />
              ) : (
                <Col>
                  <Button
                    style={{
                      backgroundColor: "#ff9800",
                      color: "#fff",
                      marginTop: "20px",
                    }}
                    onClick={() =>
                      postProduct(
                        productData,
                        () => {
                          history.push("/catalog");
                          clearConfigModalStates();
                        },
                        () => productData = [])
                    }
                  >
                    ADD
                  </Button>
                </Col>
              )}
            </Row>
          ) : ''
        }
      </Col >
    </Row >
  );
}
export default CatalogCard;
